import { useTheme } from "@mui/material";

export const useFormStyles = (isEditing: boolean) => {
  const theme = useTheme();

  return {
    "& .MuiInputBase-input.Mui-disabled": {
      WebkitTextFillColor: theme.palette.text.primary,
      color: theme.palette.text.primary,
    },

    "& .MuiFormLabel-root.Mui-disabled, & .MuiInputLabel-root.Mui-disabled": {
      color: theme.palette.text.secondary,
    },

    "& .MuiInput-underline.Mui-disabled:before": {
      borderBottomStyle: "solid",
      borderBottomColor: theme.palette.divider,
    },

    "& .MuiSelect-icon.Mui-disabled": {
      display: "none",
    },
  };
};
